export default {
  ATTACHMENTS_MODAL: {
    TITLE: `Pièces jointes`,
    SUMMARY: ``
  },
  NO_ATTACHMENTS: `Aucune pièce jointe`
}
